import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { delayNavigation } from "../../helpers/helpers";
import { useDispatch } from "react-redux";

const RightSide = ({ selectedProject, apartmentsList }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      <div className="xl:hidden col-span-full text-xl tracking-wider text-primary-bg-blue py-4 rounded-lg ">
        ნაპოვნია{" "}
        <strong className="tracking-normal">{apartmentsList.length}</strong>{" "}
        ბინა
      </div>
      <div className="hidden border-b-2 border-l-2 border-primary-dark/30 xl:col-span-8 xl:col-start-5 row-span-2 row-start-1 xl:flex items-center justify-start gap-8 text-primary-bg-blue text-2xl px-8">
        <Link
          className={`h-full flex items-center justify-center relative group cursor-pointer  ${
            location.pathname.includes("block") ? "font-bold" : ""
          } tracking-wider`}
          onClick={(event) => {
            delayNavigation(
              dispatch,
              navigate,
              `${location.pathname.replace("apartments", "block")}`,
              event
            );
          }}
          //to={`${location.pathname.replace("apartments", "block")}`}
        >
          ვიზუალური სელექცია
          <span
            className={`absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 ${
              location.pathname.includes("block")
                ? "w-full"
                : "group-hover:w-full"
            } `}
          ></span>
        </Link>
        <Link
          className={`h-full flex items-center justify-center relative group cursor-pointer  ${
            location.pathname.includes("apartments") ? "font-bold" : ""
          } tracking-wider`}
          onClick={(event) => {
            delayNavigation(
              dispatch,
              navigate,
              `${location.pathname.replace("block", "apartments")}`,
              event
            );
          }}
          //to={`${location.pathname.replace("block", "apartments")}`}
        >
          ფილტრით ძიება
          <span
            className={`absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 ${
              location.pathname.includes("apartments")
                ? "w-full"
                : "group-hover:w-full"
            } `}
          ></span>
        </Link>
      </div>

      <div className="xl:border-l-2 border-primary-dark/30 col-span-full xl:col-span-8 xl:col-start-5 row-span-10 row-start-3 flex flex-col items-start justify-start xl:pl-4 text-primary-bg-blue text-md ">
        <div className="hidden w-full xl:grid grid-cols-12 border-b-2 border-primary-dark/30">
          <span className="h-full py-5 col-span-1">ნომერი</span>
          <span className="h-full py-5 px-1 col-span-2">ტიპი</span>
          <span className="h-full py-5 col-span-2">სართული</span>
          <span className="h-full py-5 col-span-2">ფართი</span>
          <span className="h-full py-5 col-span-2">ფასი</span>
          <span className="h-full py-5 col-span-3">სტატუსი</span>
        </div>
        {apartmentsList.map((apartment, index) => {
          return (
            <React.Fragment key={apartment.number + index * Math.random()}>
              {/* Mobile Version */}
              <div
                className={`xl:hidden w-full grid grid-cols-2 md:grid-cols-6 my-4 text-sm md:text-2xl md:my-8  ${
                  apartment.isSold
                    ? "cursor-not-allowed text-primary-orange"
                    : "text-primary-bg-green hover:bg-primary-dark/5 transition-all duration-200 ease-linear cursor-pointer"
                }`}
                onClick={() => {
                  if (!apartment.isSold) {
                    delayNavigation(
                      dispatch,
                      navigate,
                      `${location.pathname}/floor/${apartment.floor}/apartment/${apartment.number}`
                    );
                  }
                }}
              >
                <span className="md:hidden h-full  py-2 border-b-2 border-r-2 border-primary-dark/30 col-span-1 flex flex-col gap-2">
                  <span>{apartment.number}</span>
                  <span>{apartment.size} კვ.მ</span>
                </span>
                <span className="md:hidden h-full pl-2 py-2 border-b-2 border-primary-dark/30 col-span-1 flex flex-col gap-2">
                  <span>სართული {apartment.floor}</span>
                  <span>{apartment.typelabel}</span>
                </span>

                <span className="hidden md:block xl:hidden h-full pr-2 py-5 border-b-2 border-r-2 border-primary-dark/30 col-span-1 ">
                  {apartment.number}
                </span>
                <span className="hidden md:block xl:hidden h-full px-2 py-5 border-b-2 border-r-2 border-primary-dark/30 col-span-2 ">
                  {apartment.typelabel}
                </span>
                <span className="hidden md:block xl:hidden h-full px-2 py-5 border-b-2 border-r-2 border-primary-dark/30 col-span-1 ">
                  სართული {apartment.floor}
                </span>
                <span className="hidden md:block xl:hidden h-full px-2 py-5 border-b-2 border-r-2 border-primary-dark/30 col-span-1 ">
                  {apartment.size} კვ.მ
                </span>
                <span className="hidden md:block xl:hidden h-full px-2 py-5 border-b-2 border-primary-dark/30 col-span-1 ">
                  ფასი
                </span>
                <span className="h-full pr-2 py-5 col-span-full flex items-center justify-center">
                  <img
                    src={apartment.typeImg}
                    alt="K2 Invest Green Home"
                    className="w-full h-full object-cover object-center"
                  />
                </span>
                <span
                  className="h-full pr-2 py-2 border-b-2 border-primary-dark col-span-full max-w-fit flex items-center justify-start text-sm md:text-xl uppercase"
                  onClick={() => {
                    if (!apartment.isSold) {
                      delayNavigation(
                        dispatch,
                        navigate,
                        `${location.pathname}/${apartment.number}`
                      );
                    }
                  }}
                >
                  view apartment
                </span>
              </div>
              {/* Desktop Version */}
              <div
                className={`hidden w-full xl:grid grid-cols-12 border-b-2 border-primary-dark/30 ${
                  apartment.isSold
                    ? "cursor-not-allowed"
                    : "hover:bg-primary-dark/5 transition-all duration-200 ease-linear cursor-pointer"
                }`}
                onClick={() => {
                  if (!apartment.isSold) {
                    delayNavigation(
                      dispatch,
                      navigate,
                      `${location.pathname}/floor/${apartment.floor}/apartment/${apartment.number}`
                    );
                  }
                }}
              >
                <span className="h-full pr-2 py-5 border-r-2 border-primary-dark/30 col-span-1">
                  {apartment.number}
                </span>
                <span className="h-full px-2 py-5 border-r-2 border-primary-dark/30 col-span-2">
                  {apartment.typelabel}
                </span>
                <span className="h-full px-2 py-5 border-r-2 border-primary-dark/30 col-span-2">
                  სართული {apartment.floor}
                </span>
                <span className="h-full px-2 py-5 border-r-2 border-primary-dark/30 col-span-2">
                  {apartment.size} კვ.მ
                </span>
                <span className="h-full px-2 py-5 border-r-2 border-primary-dark/30 col-span-2">
                  ფასი
                </span>
                <span
                  className={`h-full px-2 py-5 col-span-3 ${
                    apartment.isSold ? "text-primary-orange" : "text-green-800"
                  }`}
                >
                  {apartment.isSold ? "გაყიდული" : "თავისუფალი"}
                </span>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default RightSide;
